import React, { useState, useRef } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import './App.css';
import Hero from './components/Hero';
import WhyPMP from './components/WhyPMP';
import WhatYouLearn from './components/WhatYouLearn';
import OurSupport from './components/OurSupport';
import WhyTrustUs from './components/WhyTrustUs';
import WhoIsItFor from './components/WhoIsItFor';
import CalendarRegistration from './components/CalendarRegistration';
import TipsPractices from './components/TipsPractices';
import ContactFAQ from './components/ContactFAQ';
import Inscription from './components/inscription';
import Footer from './components/Footer';
import Navigation from './components/Navigation';
import ScrollToTopButton from './components/ScrollToTopButton';
import EligibilityModal from './components/EligibilityModal';
import MissionVision from './components/MissionVision';
import History from './components/History';
import WhyChooseUs from './components/WhyChooseUs';
import Breadcrumb from './components/Breadcrumb';
import ScrollToTop from './components/ScrollToTop'; // Assurez-vous que ce fichier existe
import Blogs from './components/blog';
import Formations from './components/formation';
import Entreprise from './components/Entreprise';
import ConduiteProjet from './components/Conduiteprojet';
import DiagnosticProjets from './components/Diagnosticprojets';
import ControleProjet from './components/Controleprojet';
import PourquoiNous from './components/pourquoinous';
import Services from './components/Services';
import WhatsAppButton from './components/WhatsAppButton';
import ArticleDetail from './components/ArticleDetails';
import PolitiqueConfidence from './components/Politique';
import MentionLegales from './components/Mentions';
import CookieManager from './components/CookieManager';
import PmpHeroSection from './landingpage/landingPMP/PmpHero';
import PmpWhatYouLearn from './landingpage/landingPMP/PmpWhatYouLearn';
import PmpWhyPMP from './landingpage/landingPMP/PmpWhyPMP';
import PmpWhyTrustUs from './landingpage/landingPMP/PmpWhyTrustUs';
import PmpWhoIsItFor from './landingpage/landingPMP/PmpWhoIsItFor';
import PmpCalendarRegistration from './landingpage/landingPMP/PmpCalendarRegistration';
import PmpTipsPractices from './landingpage/landingPMP/PmpTipsPractices';
import PmicpCalendarRegistration from './landingpage/landingPMICP/PmicpCalendarRegistration';
import PmicpHeroSection from './landingpage/landingPMICP/PmicpHero';
import PmicpEligibilityModal from './landingpage/landingPMICP/PmicpEligibilityModal';
import PmicpTipsPractices from './landingpage/landingPMICP/PmicpTipsPractices';
import PmicpWhatYouLearn from './landingpage/landingPMICP/PmicpWhatYouLearn';
import PmicpWhoIsItFor from './landingpage/landingPMICP/PmicpWhoIsItFor';
import PmicpWhyPMICP from './landingpage/landingPMICP/PmicpWhyPMICP';
import PmicpWhyTrustUs from './landingpage/landingPMICP/PmicpWhyTrustUs';
import CapmHeroSection from './landingpage/landingCAPM/CapmHero';
import CapmWhatYouLearn from './landingpage/landingCAPM/CapmWhatYouLearn';
import CapmWhyTrustUs from './landingpage/landingCAPM/CapmWhyTrustUs';
import CapmWhoIsItFor from './landingpage/landingCAPM/CapmWhoIsItFor';
import CapmCalendarRegistration from './landingpage/landingCAPM/CapmCalendarRegistration';
import CapmTipsPractices from './landingpage/landingCAPM/CapmTipsPractices';
import CapmWhyCAPM from './landingpage/landingCAPM/CapmWhyCAPM';
import CapmEligibilityModal from './landingpage/landingCAPM/CapmEligibilityModal';

// Créer un contexte pour partager la fonction de défilement
export const ScrollContext = React.createContext();

function Home({ openEligibilityModal }) {
  const calendarRef = useRef(null);

  const scrollToCalendar = () => {
    if (calendarRef.current) {
      calendarRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  return (
    <ScrollContext.Provider value={{ scrollToCalendar }}>
      <div className="home-container">
        <section className="section-hero">
          <Hero
            scrollToCalendar={scrollToCalendar}
            openEligibilityModal={openEligibilityModal}
          />
        </section>

        <section className="section-spacing">
          <Services
            scrollToCalendar={scrollToCalendar}
            openEligibilityModal={openEligibilityModal}
          />
        </section>

        <section className="section-spacing">
          <WhatYouLearn
            scrollToCalendar={scrollToCalendar}
            openEligibilityModal={openEligibilityModal}
          />
        </section>

        <section className="section-spacing">
          <ContactFAQ openEligibilityModal={openEligibilityModal} />
        </section>
      </div>
      {/* <ScrollToTopButton /> */}
    </ScrollContext.Provider>
  );
}

function Blog({ openEligibilityModal }) {
  return (
    <>
      <Breadcrumb />
      <ScrollContext.Provider>
        <Blogs openEligibilityModal={openEligibilityModal} />
      </ScrollContext.Provider>
    </>
  );
}

function AboutUs({ openEligibilityModal }) {
  return (
    <>
      <Breadcrumb />
      <div className="about-container">
        <section className="section-spacing">
          <MissionVision openEligibilityModal={openEligibilityModal} />
        </section>

        <section className="section-spacing">
          <WhyPMP openEligibilityModal={openEligibilityModal} />
        </section>

        <section className="section-spacing">
          <History openEligibilityModal={openEligibilityModal} />
        </section>

        <section className="section-spacing">
          <WhyChooseUs openEligibilityModal={openEligibilityModal} />
        </section>
      </div>
    </>
  );
}

function Contact({ openEligibilityModal }) {
  return (
    <>
      <Breadcrumb />
      <div className="contact-container">
        <section className="section-spacing">
          <ContactFAQ openEligibilityModal={openEligibilityModal} />
        </section>
      </div>
    </>
  );
}

function PMP({ openEligibilityModal }) {
  const calendarRef = useRef(null);

  const scrollToCalendar = () => {
    if (calendarRef.current) {
      calendarRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  return (
    <ScrollContext.Provider value={{ scrollToCalendar }}>
      {/* <div className="home-container"> */}
      {/* <section className="section-hero"> */}
      <PmpHeroSection
        scrollToCalendar={scrollToCalendar}
        openEligibilityModal={openEligibilityModal}
      />
      {/* </section> */}

      {/* <section className="section-spacing"> */}
      <PmpWhyPMP
        scrollToCalendar={scrollToCalendar}
        openEligibilityModal={openEligibilityModal}
      />
      {/* </section> */}

      {/* <section className="section-spacing"> */}
      <PmpWhatYouLearn
        scrollToCalendar={scrollToCalendar}
        openEligibilityModal={openEligibilityModal}
      />
      {/* </section> */}

      {/* <section className="section-spacing"> */}
      <PmpWhyTrustUs
        scrollToCalendar={scrollToCalendar}
        openEligibilityModal={openEligibilityModal}
      />
      {/* </section> */}
      <PmpWhoIsItFor
        scrollToCalendar={scrollToCalendar}
        openEligibilityModal={openEligibilityModal}
      />
      <div ref={calendarRef}>
        <PmpCalendarRegistration openEligibilityModal={openEligibilityModal} />
      </div>
      <PmpTipsPractices openEligibilityModal={openEligibilityModal} />
      <ContactFAQ openEligibilityModal={openEligibilityModal} />
      {/* </div> */}
      {/* <ScrollToTopButton /> */}
    </ScrollContext.Provider>
  );
}

function PMICP({ openEligibilityModalPmi }) {
  const calendarRef = useRef(null);

  const scrollToCalendar = () => {
    if (calendarRef.current) {
      calendarRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  return (
    <ScrollContext.Provider value={{ scrollToCalendar }}>
      {/* <div className="home-container"> */}
      {/* <section className="section-hero"> */}
      <PmicpHeroSection
        scrollToCalendar={scrollToCalendar}
        openEligibilityModalPmi={openEligibilityModalPmi}
      />
      {/* </section> */}

      {/* <section className="section-spacing"> */}
      <PmicpWhyPMICP
        scrollToCalendar={scrollToCalendar}
        openEligibilityModalPmi={openEligibilityModalPmi}
      />
      {/* </section> */}

      {/* <section className="section-spacing"> */}
      <PmicpWhatYouLearn
        scrollToCalendar={scrollToCalendar}
        openEligibilityModalPmi={openEligibilityModalPmi}
      />
      {/* </section> */}

      {/* <section className="section-spacing"> */}
      <PmicpWhyTrustUs
        scrollToCalendar={scrollToCalendar}
        openEligibilityModalPmi={openEligibilityModalPmi}
      />
      {/* </section> */}
      <PmicpWhoIsItFor
        scrollToCalendar={scrollToCalendar}
        openEligibilityModalPmi={openEligibilityModalPmi}
      />
      <div ref={calendarRef}>
        <PmicpCalendarRegistration openEligibilityModalPmi={openEligibilityModalPmi} />
      </div>
      <PmicpTipsPractices openEligibilityModalPmi={openEligibilityModalPmi} />
      <ContactFAQ openEligibilityModalPmi={openEligibilityModalPmi} />
      {/* </div> */}
      {/* <ScrollToTopButton /> */}
    </ScrollContext.Provider>
  );
}

function CAPM({ openEligibilityModalCapm }) {
  const calendarRef = useRef(null);

  const scrollToCalendar = () => {
    if (calendarRef.current) {
      calendarRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  return (
    <ScrollContext.Provider value={{ scrollToCalendar }}>
      {/* <div className="home-container"> */}
      {/* <section className="section-hero"> */}
      <CapmHeroSection
        scrollToCalendar={scrollToCalendar}
        openEligibilityModalCapm={openEligibilityModalCapm}
      />
      {/* </section> */}

      {/* <section className="section-spacing"> */}
      <CapmWhyCAPM
        scrollToCalendar={scrollToCalendar}
        openEligibilityModalCapm={openEligibilityModalCapm}
      />
      {/* </section> */}

      {/* <section className="section-spacing"> */}
      <CapmWhatYouLearn
        scrollToCalendar={scrollToCalendar}
        openEligibilityModalCapm={openEligibilityModalCapm}
      />
      {/* </section> */}

      {/* <section className="section-spacing"> */}
      <CapmWhyTrustUs
        scrollToCalendar={scrollToCalendar}
        openEligibilityModalCapm={openEligibilityModalCapm}
      />
      {/* </section> */}
      <CapmWhoIsItFor
        scrollToCalendar={scrollToCalendar}
        openEligibilityModalCapm={openEligibilityModalCapm}
      />
      <div ref={calendarRef}>
        <CapmCalendarRegistration openEligibilityModalCapm={openEligibilityModalCapm} />
      </div>
      <CapmTipsPractices openEligibilityModalCapm={openEligibilityModalCapm} />
      <ContactFAQ openEligibilityModalCapm={openEligibilityModalCapm} />
      {/* </div> */}
      {/* <ScrollToTopButton /> */}
    </ScrollContext.Provider>
  );
}


function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isEligibilityModalOpen, setIsEligibilityModalOpen] = useState(false);
  const [isEligibilityModalOpenPmi, setIsEligibilityModalOpenPmi] = useState(false);
  const [isEligibilityModalOpenCapm, setIsEligibilityModalOpenCapm] = useState(false);

  const openEligibilityModal = () => {
    setIsEligibilityModalOpen(true);
  };

  const closeEligibilityModal = () => {
    setIsEligibilityModalOpen(false);
  };

  const handleEligibilityComplete = (results) => {
    console.log('Résultats du questionnaire:', results);
  };


  const openEligibilityModalPmi = () => {
    setIsEligibilityModalOpenPmi(true);
  };

  const closeEligibilityModalPmi = () => {
    setIsEligibilityModalOpenPmi(false);
  };

  const handleEligibilityCompletePmi = (results) => {
    console.log('Résultats du questionnaire:', results);
  };


  const openEligibilityModalCapm = () => {
    setIsEligibilityModalOpenCapm(true);
  };

  const closeEligibilityModalCapm = () => {
    setIsEligibilityModalOpenCapm(false);
  };

  const handleEligibilityCompleteCapm = (results) => {
    console.log('Résultats du questionnaire:', results);
  };

  return (
    <Router>
      <div className="App">
        {/* ScrollToTop DOIT être à l'intérieur du Router mais hors des Routes */}
        <ScrollToTop />

        <Navigation
          isMenuOpen={isMenuOpen}
          setIsMenuOpen={setIsMenuOpen}
          openEligibilityModal={openEligibilityModal}
        />

        {/* Bouton WhatsApp flottant visible partout */}
        <WhatsAppButton />

        <ScrollToTopButton />

        <main>
          <Routes>
            <Route
              path="/"
              element={<Home openEligibilityModal={openEligibilityModal} />}
            />
            <Route
              path="/blog"
              element={<Blogs openEligibilityModal={openEligibilityModal} />}
            />
            <Route
              path="/a-propos-de-nous"
              element={<AboutUs openEligibilityModal={openEligibilityModal} />}
            />
            <Route
              path="/contactez-nous"
              element={<Contact openEligibilityModal={openEligibilityModal} />}
            />
            <Route
              path="/formations"
              element={<Formations openEligibilityModal={openEligibilityModal} />}
            />
            <Route
              path="/entreprises"
              element={<Entreprise openEligibilityModal={openEligibilityModal} />}
            />
            <Route
              path="/entreprises/conduite-projet"
              element={<ConduiteProjet openEligibilityModal={openEligibilityModal} />}
            />
            <Route
              path="/entreprises/diagnostic-projets"
              element={<DiagnosticProjets openEligibilityModal={openEligibilityModal} />}
            />
            <Route
              path="/entreprises/controle-projet"
              element={<ControleProjet openEligibilityModal={openEligibilityModal} />}
            />
            <Route
              path="/pourquoi-nous"
              element={<PourquoiNous openEligibilityModal={openEligibilityModal} />}
            />
            <Route
              path="/blog/:slug"
              element={<ArticleDetail openEligibilityModal={openEligibilityModal} />}
            />
            <Route
              path="/politique-confidentialite"
              element={<PolitiqueConfidence openEligibilityModal={openEligibilityModal} />}
            />
            <Route
              path="/mentions-legales"
              element={<MentionLegales openEligibilityModal={openEligibilityModal} />}
            />


            <Route
              path="/preparation-au-pmp"
              element={<PMP openEligibilityModal={openEligibilityModal} />}
            />
            <Route
              path="/preparation-au-pmi-cp"
              element={<PMICP openEligibilityModalPmi={openEligibilityModalPmi} />}
            />
            <Route
              path="/preparation-au-capm"
              element={<CAPM openEligibilityModalCapm={openEligibilityModalCapm} />}
            />

            <Route path="/inscription" element={<Inscription />} />

          </Routes>
        </main>

        <Footer />

        <EligibilityModal
          isOpen={isEligibilityModalOpen}
          onClose={closeEligibilityModal}
          onComplete={handleEligibilityComplete}
        />

        <PmicpEligibilityModal
          isOpen={isEligibilityModalOpenPmi}
          onClose={closeEligibilityModalPmi}
          onComplete={handleEligibilityCompletePmi}
        />

        <CapmEligibilityModal
          isOpen={isEligibilityModalOpenCapm}
          onClose={closeEligibilityModalCapm}
          onComplete={handleEligibilityCompleteCapm}
        />

        <CookieManager />
      </div>
    </Router>
  );
}

export default App;